import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, " 자, 원더플 피플이라면누구나 맞출 수 있는 퀴즈! "),
  /*#__PURE__*/_createElementVNode("div", null, " 먼저 확인해볼까요? "),
  /*#__PURE__*/_createElementVNode("div", { class: "color-primary tip" }, " (* 끝까지 완료해주셔야 신청 접수가 이뤄집니다.) ")
], -1)
const _hoisted_2 = { class: "dialog-content quiz-content" }

import { reactive, ref } from 'vue';
import _ from 'lodash';
import { ISurveySection, ISurveyQuestion, ISurveryOption, ISurvey } from '@/types/survey';
import dayjs from 'dayjs';
import { IProgram } from '@/types/program';
import { request } from '@/utils';
import { ColorVariants } from '@/constants';

export interface Expose {
  startQuiz(quiz: ISurvey): void
}

interface Props {
  program: IProgram;
  className?: string;
}

interface Emits {
  (event: 'success'): void;
}


  const __default__ = {
    inheritAttrs: false
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    program: null,
    className: { default: 'dialog-campaign dialog-campaign-quiz' }
  },
  emits: ["success"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
  (event: 'success'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { program: IProgram, className: string }




const OPTION_NAMES = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];

const dialog = reactive({
  ready: false,
  quiz: false,
  quizAnswerConfirm: false,
  quizeCancel: false,
});

let questions: ISurveyQuestion[] = [];
let questionForm: {
  survey_id: number;
  type: 'CampaignResponse';
  program_id: number;
  started_at: string;
  completed_at: string;
  answers_attributes: {
    value?: string; // 简答题传
    value_type?: 'text'; // 简答题传
    survey_question_id: number;
    survey_option_ids?: number[] // 选择题传
  }[]
};

function closeDialog(dialogName?: string) {
  if (dialogName) {
    dialog[dialogName] = false;
  } else {
    _.forEach(dialog, (val, key) => {
      if (val) {
        dialog[key] = false;
      }
    });
  }
}

function showDialog(dialogName: string) {
  closeDialog();
  dialog[dialogName] = true;
}

const question = ref<ISurveyQuestion>();
async function nextQuestion() {
  if (questions.length > questionForm.answers_attributes.length) {
    question.value = questions[questionForm.answers_attributes.length];
    showDialog('quiz');
  } else {
    // 没有下一题了
    questionForm.completed_at = dayjs().toISOString();
    await request.post('responses', questionForm);
    emits('success');
  }
}

const quizInput = ref<string>('');
function handleAnswerQuiz(option?: ISurveryOption) {
  if (option) {
    if (option.is_correct) {
      questionForm.answers_attributes.push({
        survey_question_id: (question.value as ISurveyQuestion).id as number,
        survey_option_ids: [option.id as number]
      });
      return nextQuestion();
    }
  }
  if (quizInput.value) {
    questionForm.answers_attributes.push({
      survey_question_id: (question.value as ISurveyQuestion).id as number,
      value: quizInput.value,
      value_type: 'text'
    });
    // 清空input
    quizInput.value = '';
    return nextQuestion();
  }
  // 答案不正确
  showDialog('quizAnswerConfirm');
}

function handleCancelQuiz() {
  showDialog('quizeCancel');
}

function startQuiz (quiz: ISurvey) {
  const surveySections: ISurveySection[] = _.get(quiz, 'survey_sections') || [];
  questions = _.flatMap(surveySections.map(item => item.survey_questions));
  questionForm = {
    survey_id: quiz.id as number,
    type: 'CampaignResponse',
    program_id: props.program.id,
    started_at: dayjs().toISOString(),
    completed_at: '',
    answers_attributes: []
  };
  showDialog('ready');
};

expose({
  startQuiz
});

return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!
  const _component_b_form_input = _resolveComponent("b-form-input")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).ready,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).ready) = $event)),
      class: _normalizeClass([__props.className]),
      content: "원더플 지구를 위한 첫 걸음을 시작하셨네요!",
      btns: [
        { text: '닫기', style: _unref(ColorVariants).dark, click: () => closeDialog() },
        { text: '시작하기', style: _unref(ColorVariants).primary, click: () => nextQuestion() }
      ]
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["visible", "class", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).quizAnswerConfirm,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialog).quizAnswerConfirm) = $event)),
      class: _normalizeClass([__props.className]),
      content: "정말일까요?",
      btns: [
        { text: '다시 풀기', style: _unref(ColorVariants).primary, click: () => showDialog('quiz') }
      ]
    }, null, 8, ["visible", "class", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).quizeCancel,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).quizeCancel) = $event)),
      class: _normalizeClass([__props.className]),
      content: `정말 신청을 취소하시겠습니까?
  닫기 버튼을 클릭하면 캠페인 신청이 취소됩니다.
  `,
      btns: [
        { text: '닫기', style: _unref(ColorVariants).dark, click: () => closeDialog() },
        { text: '돌아가기', style: _unref(ColorVariants).primary, click: () => showDialog('quiz') },
      ]
    }, null, 8, ["visible", "class", "content", "btns"]),
    (question.value)
      ? (_openBlock(), _createBlock(_component_AppDialog, {
          key: 0,
          visible: _unref(dialog).quiz,
          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_unref(dialog).quiz) = $event)),
          content: question.value.text,
          btns:  question.value.kind === 'input' ? [
        { text: '닫기', style: _unref(ColorVariants).dark, click: () => handleCancelQuiz() },
        { text: '적용하기', style: _unref(ColorVariants).primary, disabled: !quizInput.value, click: () => handleAnswerQuiz() },
      ] : [],
          class: _normalizeClass([__props.className])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (question.value.kind === 'choice')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(question.value.survey_options, (item, index) => {
                    return (_openBlock(), _createBlock(_component_AppLoadingButton, {
                      key: index,
                      class: "choice-btn",
                      pill: "",
                      variant: _unref(ColorVariants).info,
                      onClick: ($event: any) => (handleAnswerQuiz(item))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(OPTION_NAMES[index]) + "." + _toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["variant", "onClick"]))
                  }), 128))
                : _createCommentVNode("", true),
              (question.value.kind === 'input')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", null, _toDisplayString(question.value.tips), 1),
                    _createVNode(_component_b_form_input, {
                      modelValue: quizInput.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((quizInput).value = $event)),
                      modelModifiers: { trim: true },
                      class: "input",
                      required: "",
                      type: "text"
                    }, null, 8, ["modelValue"])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["visible", "content", "btns", "class"]))
      : _createCommentVNode("", true)
  ]))
}
}

})